<table style="margin: 3% 12%;font-size: xx-large;" class="table table-hover table-bordered table-striped">
  <thead>
    <tr>
      <td>Buyer PassCode</td>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of PassCodeList">
      <td>{{item.PassCode}}</td>
    </tr>
  </tbody>
</table>
<table style="margin: 3% 12%;font-size: xx-large;" class="table table-hover table-bordered table-striped">
  <thead>
    <tr>
      <td>Visitor PassCode</td>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of PassCodeList2">
      <td>{{item.OTP}}</td>
    </tr>
  </tbody>
</table>